import { isString } from '../common/utils/stringify';

const isValidGuid = (value?: string): boolean => {
  if (!isString(value) || !value) {
    return false;
  }
  const match = value.match(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  );
  return match !== null && match.length > 0;
};

export default isValidGuid;
